export default __webpack_public_path__ + "static/media/better-deal.f265b7df.jpg";